import { useState } from 'react';
import { Container } from 'react-bootstrap';

import Detail from './Detail';
import ChatWindow from './ChatWindow';
import DraggableItem from './DraggableItem';
import CandidateSelection from './CandidateSelection';
import JobDescriptionSummary from './JobDescriptionSummary';
import { useAppDispatch } from '../../../store/hooks';
import { getJobNPDetail } from '../../../store/features/dashboard';
import { getStoredDistance } from '../../../utility/distancePrefs';

const Description = ({
    step,
    jobId,
    jobAction,
    aboutFor,
    jobData,
    loading,
    setPercentageFitValue,
    hideChatWindow,
    setHideChatWindow,
    refreshJobData,
    idealizeJobData,
    setShowLoader,
    setHavesData,
    handleClose,
    setCandidateLoading,
    assignedTier
}: any) => {
    const dispatch = useAppDispatch();
    const [updatedNearPeer, setUpdatedNearPeer] = useState({});

    const fetchNPRanking = async () => {
        try {
            const res = await dispatch(getJobNPDetail(jobData?.id)).unwrap();
            setUpdatedNearPeer(res?.data);
        } catch (error) {
            console.info('Error during fetching user details:', error);
        }
    };

    const getJobDistance = () => {
        // Prefer the most recently selected distance saved per job
        const saved = getStoredDistance(jobId || jobData?.id);
        if (saved !== undefined) return saved;

        if (typeof jobData?.distance_in_miles === 'string') {
            return null; // for unlimited distance value return
        }
        return jobData?.distance_in_miles || null;
    }

    return (
        <>
            <Container>
                {step === 'job-description' && (
                    <Detail
                        jobData={jobData}
                        loading={loading}
                        jobAction={jobAction}
                        refreshJobData={refreshJobData}
                        setMShowLoader={setShowLoader}
                        updatedNearPeer={updatedNearPeer}
                        fetchNPRanking={fetchNPRanking}
                        handleClose={handleClose}
                    />
                )}
                {step === 'idealize-candidate' && (
                    <DraggableItem
                        jobData={jobData}
                        idealizeJobData={idealizeJobData}
                        loading={loading}
                        jobAction={jobAction}
                        setHavesData={setHavesData}
                        handleClose={handleClose}
                    />
                )}

                {((step === 'job-description') || (step === 'idealize-candidate')) && (
                    <ChatWindow
                        conversationId={step === 'job-description' ? jobData?.job_conversation_id : jobData?.icp_conversation_id}
                        step={step}
                        jobId={jobId || jobData?.id}
                        hideChatWindow={hideChatWindow}
                        jobAction={jobAction}
                        jobTitle={jobData?.title}
                        jobNearPeer={jobData?.near_pear_ranking}
                        updatedNearPeer={updatedNearPeer}
                        companyName={jobData?.company_name}
                        setHideChatWindow={setHideChatWindow}
                        fetchNPRanking={fetchNPRanking}
                        refreshJobData={refreshJobData}
                    />
                )}

                {step === 'job-description-summary' && (
                    <JobDescriptionSummary
                        jobData={jobData}
                        aboutFor={aboutFor}
                        loading={loading}
                        handleClose={handleClose}
                        assignedTierFromParent={assignedTier}
                    />
                )}
                {step === 'candidate-selection' && (
                    <CandidateSelection
                        aboutFor={aboutFor}
                        jobId={jobId || jobData?.id}
                        jobDistance={getJobDistance()}
                        jobLocation={jobData?.location?.title}
                        setPercentageFitValue={setPercentageFitValue}
                        loading={loading}
                        setCandidateLoading={setCandidateLoading}
                    />
                )}
            </Container>
        </>
    );
};

export default Description;
